import {
  BRANCHES_COLUMNS,
  REGIONS_COLUMNS,
  COUNTRIES_COLUMNS,
  COUNTRY_COEF_COLUMNS,
  CURRENCY_COLUMNS,
  PROFILE_COLUMNS,
  REASON_LEAVE_COLUMNS,
  RECRUITMENT_METHODS_COLUMNS,
  SYNTEC_COLUMNS,
  SYNTEC_POS_COEF_COLUMNS,
  JOBS_COLUMNS,
  JOB_CATEGORIES_COLUMNS,
  TTV_COLUMNS,
  APPEAL_COLUMNS,
  TYPE_COMPANIES_COLUMNS,
  EXCHANGE_RATE,
  SECTOR_COLUMNS,
  BACKUP_MANAGER_COLUMNS,
  COUNTRY_HOLIDAYS_COLUMNS,
  SYNTEC_POS_COEF_STAFF_COLUMNS,
  DOCUMENT_COLUMNS,
} from "constants/bo-columns";
import { ENTITIES } from "constants/constants";
import EditableCell from "core/inputs/editable-cell/EditableCell";
import { renderIf } from "./helper";
import { FormattedMessage } from "react-intl";

export const ENTITY_COLUMNS_MAP = {
  [ENTITIES.BRANCH]: BRANCHES_COLUMNS,
  [ENTITIES.REGIONS]: REGIONS_COLUMNS,
  [ENTITIES.COUNTRIES]: COUNTRIES_COLUMNS,
  [ENTITIES.COUNTRY_COEF]: COUNTRY_COEF_COLUMNS,
  [ENTITIES.CURRENCY]: CURRENCY_COLUMNS,
  [ENTITIES.PROFILE]: PROFILE_COLUMNS,
  [ENTITIES.REASON_LEAVE]: REASON_LEAVE_COLUMNS,
  [ENTITIES.RECRUITMENT_METHOD]: RECRUITMENT_METHODS_COLUMNS,
  [ENTITIES.SYNTEC]: SYNTEC_COLUMNS,
  [ENTITIES.SYNTEC_POS_COEF]: SYNTEC_POS_COEF_COLUMNS,
  [ENTITIES.SYNTEC_POS_COEF_STAFF]: SYNTEC_POS_COEF_STAFF_COLUMNS,
  [ENTITIES.JOBS]: JOBS_COLUMNS,
  [ENTITIES.JOB_CATEGORIES]: JOB_CATEGORIES_COLUMNS,
  [ENTITIES.TTV]: TTV_COLUMNS,
  [ENTITIES.APPEAL]: APPEAL_COLUMNS,
  [ENTITIES.TYPE_COMPANIES]: TYPE_COMPANIES_COLUMNS,
  [ENTITIES.EXCHANGE_RATE]: EXCHANGE_RATE,
  [ENTITIES.SECTOR]: SECTOR_COLUMNS,
  [ENTITIES.BACKUP_MANAGER]: BACKUP_MANAGER_COLUMNS,
  [ENTITIES.COUNTRY_HOLIDAYS]: COUNTRY_HOLIDAYS_COLUMNS,
  [ENTITIES.DOCUMENT]: DOCUMENT_COLUMNS,
};

export const createColElement = ({ e, entity }) => (
  <span
    style={{
      fontWeight: "bold",
    }}
  >
    <FormattedMessage
      id={`admin_${entity}_page_table_name_${e.col.toLowerCase()}`}
      defaultMessage={e.col.toUpperCase()}
    />
    {renderIf(e.mandatory, "*", "")}
  </span>
);

export const createEditableCell = ({
  e,
  formValues,
  setFormValues,
  updateData,
  search,
  searchRole,
  watchFormInput,
  getYear,
  minDate,
}) => (
  <EditableCell
    getYear={getYear}
    minDate={minDate}
    value={formValues[e.col] ?? ""}
    variable={e}
    id={e.id}
    updateData={(variable, e) => {
      updateData(variable, e);
      if (watchFormInput) {
        watchFormInput({ input: variable?.col, value: e });
      }
    }}
    formValues={formValues}
    search={renderIf(e.col === "associates", searchRole, search)}
    onRemove={(entity, val) => {
      if (watchFormInput) {
        watchFormInput({
          input: entity,
          value: formValues[entity].filter((elm) => elm.value !== val),
        });
      }
      setFormValues({
        ...formValues,
        [entity]: formValues[entity].filter((elm) => elm.value !== val),
      });
    }}
  />
);
